import React from 'react'
import styled from 'styled-components'
import { MainButton } from '@appearance/styled'

export default ({ collection, label }) => {
    return (
        <StyledMainButton>
            <HyperLink
                href={
                    'https://api.markid.co.il/index.php/api/get_all_' +
                    // 'http://markidim.codelovers-solutions.com/api/index.php/api/get_all_' +
                    collection +
                    '_csv' +
                    window.location.search
                }
            >
                {label}
            </HyperLink>
        </StyledMainButton>
    )
}

const StyledMainButton = styled(MainButton)`
    align-self: flex-end;
    margin-bottom: 12px;

    & > a {
        color: #fff;
    }
    & > a:focus {
        outline: none;
    }
`

const HyperLink = styled.a`
    color: #fff;

    &:hover {
        color: #fff;
        text-decoration: none;
    }
`
